import { mondayOf } from './week';

/**
 * Where time is entered (Michael 2026-09-18: ONE place — Time Entry → Crew).
 * Every link that used to open the old weekly sheet (/time/:job/:week) is
 * built here, so the job and the week arrive preselected on the Crew tab
 * (`?tab=crew&job=&week=`, the params CrewWeekTab reads). The old sheets
 * stay readable at OLD_SHEETS_PATH; nothing links there except Time Entry's
 * footer. No DOM.
 */
export const TIME_ENTRY_PATH = '/time/entries';
export const OLD_SHEETS_PATH = '/time/sheets';

/** Time Entry → Crew for one job and week; either may be absent (the tab remembers the last job, and opens this week). */
export function crewWeekPath(projectId?: string | null, week?: string | null): string {
  const q = new URLSearchParams({ tab: 'crew' });
  if (projectId) q.set('job', projectId);
  const monday = week ? mondayOf(week) : '';
  if (monday) q.set('week', monday);
  return `${TIME_ENTRY_PATH}?${q.toString()}`;
}

/** One old weekly sheet (read-only, not payroll). */
export function oldSheetPath(projectId: string, weekStart: string): string {
  return `${OLD_SHEETS_PATH}/${projectId}/${weekStart}`;
}
